import { LabelText, SpanText, Text, Textarea } from "../../../design";
import React, { useEffect, useState } from "react";
import { Radio } from 'antd';
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { normalTextFontSize, smallTextFontSize, textAreaHeight } from "../../../utils/reseponsive";

type Props = {
  label: string,
  description: string,
  control: any,
  errors: any,
  name: string,
  isRequired: boolean,
  isPreview: boolean,
  isAdaptive: boolean,
  selectedAccount: Object,
  callOptions: Function,
  data: Object,
}

const InputLargeText = (props: Props) => {
  const { label, description, control, errors, name, isRequired, isPreview, isAdaptive, selectedAccount, callOptions, data } = props;
  const [charactersLength, setCharactersLength] = useState(255);
  const { gid } = selectedAccount;

  const [value, setValue] = useState(1);

  const accntGid = [
    "account-441a1ebbae8a4e3d95abda2e86ccf7d6",
    "account-ad9a2ae39c5f4b3b84d44e6671630077",
    "account-ff1166de992e429c82eb02f86dfdbbab"
  ];

  useEffect(() => {
    if (accntGid.includes(gid)) {
      if (gid === 'account-441a1ebbae8a4e3d95abda2e86ccf7d6') {
        data.Key = 1;
        data.DisplayName = 'Lunch Group 1- 11: 30 AM to 12: 30 PM(Check -in starts at 11 AM)';
        data.Value = 'Lunch Group 1 - 11: 30 AM to 12: 30 PM(Check -in starts at 11 AM)';
        data.acceptText = true;
        callOptions(data)
      } else if (gid === 'account-ad9a2ae39c5f4b3b84d44e6671630077') {
        data.Key = 1;
        data.DisplayName = 'Group 1 - 11: 30 AM to 12: 15 PM';
        data.Value = 'Group 1 - 11: 30 AM to 12: 15 PM';
        data.acceptText = true;
        callOptions(data)
      } else if (gid === 'account-ff1166de992e429c82eb02f86dfdbbab') {
        data.Key = 1;
        data.DisplayName = 'NORTH';
        data.Value = 'NORTH';
        data.acceptText = true;
        callOptions(data);
      }
    }
  }, []);

  const updateGroup = (e) => {
    if (accntGid.includes(gid)) {
      if (gid === 'account-441a1ebbae8a4e3d95abda2e86ccf7d6') {
        setValue(e.target.value);
        if (e.target.value === 1) {
          data.Key = 1;
          data.DisplayName = 'Lunch Group 1 - 11: 30 AM to 12: 30 PM(Check -in starts at 11 AM)';
          data.Value = 'Lunch Group 1 - 11: 30 AM to 12: 30 PM(Check -in starts at 11 AM)';
          data.acceptText = true;
        } else if (e.target.value === 2) {
          data.Key = 2;
          data.DisplayName = 'Lunch Group 2 - 12:45 PM to 1:45 PM (Check-in starts at 12:15 PM)';
          data.Value = 'Lunch Group 2 - 12:45 PM to 1:45 PM (Check-in starts at 12:15 PM)';
          data.acceptText = true;
        } else if (e.target.value === 3) {
          data.Key = 3;
          data.DisplayName = 'Lunch Group 3 - 2:00 PM to 3:00 PM (Check-in starts at 1:30 PM)';
          data.Value = 'Lunch Group 3 - 2:00 PM to 3:00 PM (Check-in starts at 1:30 PM)';
          data.acceptText = true;
        }
        callOptions(data);
      } else if (gid === 'account-ad9a2ae39c5f4b3b84d44e6671630077') {
        setValue(e.target.value);
        if (e.target.value === 1) {
          data.Key = 1;
          data.DisplayName = 'Group 1 - 11: 30 AM to 12: 15 PM';
          data.Value = 'Group 1 - 11: 30 AM to 12: 15 PM';
          data.acceptText = true;
        } else if (e.target.value === 2) {
          data.Key = 2;
          data.DisplayName = 'Group 2 - 12:15 PM to 1:00 PM';
          data.Value = 'Group 2 - 12:15 PM to 1:00 PM';
          data.acceptText = true;
        } else if (e.target.value === 3) {
          data.Key = 3;
          data.DisplayName = 'Group 3 - 1:00 PM to 1:45 PM';
          data.Value = 'Group 3 - 1:00 PM to 1:45 PM';
          data.acceptText = true;
        } else if (e.target.value === 4) {
          data.Key = 4;
          data.DisplayName = 'Group 4 - 1:45 PM to 2:30 PM';
          data.Value = 'Group 4 - 1:45 PM to 2:30 PM';
          data.acceptText = true;
        } else if (e.target.value === 5) {
          data.Key = 5;
          data.DisplayName = 'Group 5 - 2:30 PM to 3:15 PM';
          data.Value = 'Group 5 - 2:30 PM to 3:15 PM';
          data.acceptText = true;
        }
        callOptions(data);
      } else if (gid === 'account-ff1166de992e429c82eb02f86dfdbbab') {
        setValue(e.target.value);
        if (e.target.value === 1) {
          data.Key = 1;
          data.DisplayName = 'NORTH';
          data.Value = 'NORTH';
          data.acceptText = true;
        } else if (e.target.value === 2) {
          data.Key = 2;
          data.DisplayName = 'SOUTH';
          data.Value = 'SOUTH';
          data.acceptText = true;
        }
        callOptions(data);
      }
    }
  };

  return (
    <>
      <div className="form-group row mb-0 no-gutters align-items-center">
        <div className="col-sm-5">
          <LabelText fontSize={normalTextFontSize(isPreview, isAdaptive)} color="#0000000"
            hidden={!label} htmlFor="alpha" className="col-form-label font-weight-bolder m-0 text-break">{label}
            {/* <SpanText className="pl-2" hidden={isRequired} color="rgba(0, 0, 0, 0.6)"
                      fontSize={smallTextFontSize(isPreview, isAdaptive)}>(Optional)</SpanText> */}
          </LabelText>
        </div>
        {
          accntGid.includes(gid) ? (
            <div className="col-sm-7">
              {
                gid === 'account-441a1ebbae8a4e3d95abda2e86ccf7d6' || gid === 'account-ad9a2ae39c5f4b3b84d44e6671630077' ? (
              <LabelText fontSize={normalTextFontSize(isPreview, isAdaptive)} color="#0000000"
                htmlFor="alpha" className="col-form-label font-weight-bolder m-0 text-break">
                <span style={{ fontWeight: '600' }}>Select a lunch group of preference, each group will have maximum of 180 people.</span><span style={{ color: 'red' }}>*</span><br />
                Note that you can't change a group later
              </LabelText> ) : (<div></div>)
              }
              {
                gid === 'account-441a1ebbae8a4e3d95abda2e86ccf7d6' || gid === 'account-ad9a2ae39c5f4b3b84d44e6671630077' ? (
                  <Radio.Group value={value} onChange={updateGroup}>
                      <Radio className="col-form-label font-weight-bolder m-0 text-break" value={1}>&nbsp;Lunch Group 1 - 11: 30 AM to 12: 30 PM(Check -in starts at 11 AM)</Radio><br />
                      <Radio disabled className="col-form-label font-weight-bolder m-0 text-break" value={2}>&nbsp;Lunch Group 2 - 12:45 PM to 1:45 PM (Check-in starts at 12:15 PM) (SOLD OUT)</Radio><br />
                      <Radio className="col-form-label font-weight-bolder m-0 text-break" value={3}>&nbsp;Lunch Group 3 - 2:00 PM to 3:00 PM (Check-in starts at 1:30 PM)</Radio>
                  </Radio.Group>
                ) : (<div></div>)
              }
              {
                gid === 'account-ff1166de992e429c82eb02f86dfdbbab' ? (
                  <Radio.Group value={value} onChange={updateGroup}>
                      <Radio className="col-form-label font-weight-bolder m-0 text-break" value={1}>&nbsp;NORTH<br /><span style={{ fontWeight: '400' }}>2000 Camanche Road Ione, CA 95640 (North Shore is 12miles - 20mins Drive from South Shore)</span></Radio><br />
                      <Radio className="col-form-label font-weight-bolder m-0 text-break" value={2}>&nbsp;SOUTH<br /><span style={{ fontWeight: '400' }}>11700 Wade Lane Valley Springs, CA 95252</span></Radio>
                  </Radio.Group>
                ) : (<div></div>)
              }

            </div>
          ) : (
            <div className="col-sm-7">
              <Controller
                defaultValue={''}
                border="1px solid #29B1CC !important"
                control={control}
                name={name}
                rules={{
                  required: isRequired && "This field is required",
                }}
                as={<Textarea type="text" onInput={({ target }) => setCharactersLength(255 - target.value.length)} maxLength={255} width="100%" fontSize={smallTextFontSize(isPreview, isAdaptive)} height={textAreaHeight(24, isPreview, isAdaptive)} className="bg-white mb-0" rows="4" />}
              />
              <SpanText className="text-mute mb-1" fontSize={smallTextFontSize(isPreview, isAdaptive)}>Maximum 255 Characters - Characters left {charactersLength}</SpanText>
              <ErrorMessage
                errors={errors}
                name={name}
                render={({ message }) => (
                  <Text fontSize={smallTextFontSize(isPreview, isAdaptive)} marginTop="0" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </div>
          )
        }
      </div>
      <div hidden={!description} className="col-sm-10 px-0">
        <LabelText className="text-mute mt-1" fontSize={smallTextFontSize(isPreview, isAdaptive)}>{description}</LabelText>
      </div>
    </>
  )
};

export default InputLargeText
